import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

Vue.prototype.backendURL = 'http://it-backend.synagro.local/'
Vue.prototype.backendURLPDF = 'https://it-api.synagro.com.ar/'

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('usertoken') || '',
    tokenpdf: localStorage.getItem('usertokenpdf') || '',
    user : {}
  },
  mutations: {
    auth_request(state){
        state.status = 'loading'
      },
    auth_success(state, token, user){
        state.status = 'success'
        state.token = token
        state.user = user
    },
        auth_error(state){
        state.status = 'error'
    },
        logout(state){
        state.status = ''
        state.token = ''
    },
  },
  actions: {
    login({commit}, user){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios({url: Vue.prototype.backendURL + 'api/v1.0/auth/', data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.token
            localStorage.setItem('usertoken', token)
            localStorage.setItem('username', user.username)
            const formData = new FormData();
            formData.append('username', user.username);
            formData.append('password', user.password);
            axios({url: Vue.prototype.backendURLPDF + 'auth/token', 
              data: formData, 
              method: 'POST',
              headers: {
                'Content-Type': 'multipart/form-data',
              }
            })
            .then(resp => {              
              const tokenpdf = resp.data.access_token
              console.log(tokenpdf)
              localStorage.setItem('usertokenpdf', tokenpdf )
              
          })
            commit('auth_success', token, user)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('usertoken')
            reject(err)
          })
        })
    },
    logout({commit}){
        return new Promise((resolve) => {
          commit('logout')
          let url = Vue.prototype.backendURL + 'api/v1.0/logout/';
          axios.post(url)
          .then( result => {
            console.log(result.data)
          })
          delete axios.defaults.headers.common['Authorization']
          localStorage.removeItem('usertoken')
          localStorage.removeItem('usertokenpdf')
          localStorage.removeItem('username')
          resolve()
        })
      }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})
